module.exports = __webpack_public_path__ + "static/media/edu-room-img--1.134f4e1c.svg";